import { ReactElement, useMemo } from 'react'
import { useAppStore } from '@stores'
import FloorplanLineLoadGroupElement from './components/FloorplanLineLoadGroupElement'
import { groupFloorplanLineLoads } from './utils'

interface Props {
  loads: LineLoadWithDomain[]
  /** Largest line load value of the project; all widths scale proportionally to it. */
  maxMagnitude: number
}

/**
 * 2D line loads in the floorplan, in the point-load style. Loads with the same extent share one
 * geometry and get one label each (two for loads that vary along their length).
 */
const FloorplanLineLoadsMesh = ({ loads, maxMagnitude }: Props): ReactElement => {
  const maxWidth = useAppStore(state => state.loadRenderConfig.lineLoads.floorplanMaxWidth)
  const groups = useMemo(
    () => groupFloorplanLineLoads(loads, { maxWidth, maxMagnitude }),
    [loads, maxWidth, maxMagnitude],
  )

  return (
    <group position={[0, 0, 0.0001]}>
      {groups.map(group => (
        <FloorplanLineLoadGroupElement key={group.key} group={group} />
      ))}
    </group>
  )
}

export default FloorplanLineLoadsMesh
